import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (32 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisOdeme = {
  // Admin, bir kullanıcının FATURA bilgisini günceller (yalnızca billing alanı gönderilir).
  UpdateUserBilling(token, userID, billing) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { userID, billing }
    });
  },

  // --- Ödemeler (cari) — MOCK ödeme akışı; kart verisi olarak yalnız MASKELİ meta gönderilir ---
  // Oda yetkilisinin ADINA ödeme görebileceği oda sahipleri: {owners:[{customerID,name,rooms[]}]}.
  GetAuthorizedPaymentOwners(token, permission = "payments_view") {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-authorized-payment-owners`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { permission }
    });
  },

  // Oda sahibinin fatura bilgisini OKUR (billing_info_view). Dönüş: {ownerID, ownerName,
  // billing, nationality, canEdit}. Profil alanları (telefon vb.) DÖNMEZ.
  GetOwnerBillingInfo(token, ownerID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-owner-billing-info`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { ownerID }
    });
  },

  // Oda sahibi ADINA fatura bilgisi yazar (YALNIZ billing alanı). Yetki BE'de kontrol edilir:
  // payments_edit=1 && billing_info_edit=1. Kayıt yetkilinin değil, ODA SAHİBİNİN üstüne gider.
  UpdateOwnerBillingInfo(token, { ownerID, billing }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-owner-billing-info`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { ownerID, billing }
    });
  },

  GetPaymentLedger(token, customerID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-payment-ledger`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: customerID ? { customerID } : {}
    });
  },

  // debtIDs: ödenecek borç satırı ID'leri; card: { holder, last4, brand } — PAN/CVV ASLA gönderilmez.
  PayPaymentDebts(token, debtIDs, card) {
    return axios({
      method: "post",
      url: `${API_URL}flow/pay-payment-debts`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        debtIDs,
        cardHolder: card?.holder || "",
        cardLast4: card?.last4 || "",
        cardBrand: card?.brand || "",
      }
    });
  },

  // Admin/merchant: ödenmemiş borçları elle "Ödendi" işaretler (panel dışı tahsilat).
  // customerID zorunlu (admin başka müşteriyi, merchant kendi firmasının borcunu işaretler).
  // paidDate (unix sn, isteğe bağlı): ödemenin yapıldığı gün; verilmezse BE "şimdi" yazar.
  MarkPaymentDebtsPaid(token, customerID, debtIDs, paidDate) {
    return axios({
      method: "post",
      url: `${API_URL}flow/mark-payment-debts-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { customerID, debtIDs, ...(paidDate ? { paidDate } : {}) }
    });
  },

  // ELLE "Ödendi" işaretlenmiş borcun ödeme tarihini düzeltir (BE payments::updateDebtPaidDate;
  // Lidio ile ödenmiş satır reddedilir).
  UpdatePaymentDebtPaidDate(token, customerID, debtID, paidDate) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-payment-debt-paid-date`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { customerID, debtID, paidDate }
    });
  },

  // Manuel tahsilat (ödeme) satırı — admin/merchant müşteri carisine elle ekler/düzenler/siler.
  // amount: TL (>0), paymentDate: unix saniye, description: opsiyonel.
  // kdvIncluded=false gönderilirse BE girilen NET tutara KDV'yi EKLER (cari satırları hep KDV
  // dahil tutulur). corporationID opsiyoneldir ve yalnız admin için geçerlidir; BE bunu Lidio
  // subseller listesine karşı doğrular (kayıtsız firmaya yazılan borç ödenemezdi).
  AddPaymentEntry(token, customerID, { amount, description = "", paymentDate, kdvIncluded = true, corporationID = "" }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-payment-entry`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerID, amount, description, paymentDate, kdvIncluded, corporationID },
    });
  },

  UpdatePaymentEntry(token, customerID, paymentID, { amount, description, paymentDate }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-payment-entry`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerID, paymentID, amount, description, paymentDate },
    });
  },

  RemovePaymentEntry(token, customerID, paymentID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-payment-entry`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerID, paymentID },
    });
  },

  // Ödemeler listesi: müşteri kırılımı olmadan tüm cari hareketler (admin/merchant).
  GetPaymentEntries(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-payment-entries`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },

  // Partner Genel Bakış: Yaklaşan / Yapılan Ödemeler (Lidio hakedişleri; BE payments::getMerchantPayouts).
  // → { summary, upcoming: [...], paid: [...], escrowDays, truncated }. Yetki: "merchant-overview" sayfası.
  GetMerchantPayouts(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-merchant-payouts`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },

  // Ödeme sistemi (sağlayıcı) komisyon ayarları — firma bazlı, kart grubuna göre (default/amex).
  GetPaymentProviderFees(token, corporationId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-payment-provider-fees`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId },
    });
  },

  SetPaymentProviderFees(token, corporationId, groups) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-payment-provider-fees`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId, groups },
    });
  },

  // --- Lidio pazaryeri yönetimi (admin: Firma Profili > Komisyon) ---
  // Firmanın Lidio kaydı (subseller) + komisyon oranı; ödeme bu ikisi olmadan başlatılamaz.
  PaymentLidiaGetSubsellers(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-get-subsellers`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },

  PaymentLidiaSyncSubseller(token, payload) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-sync-subseller`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: payload,
    });
  },

  PaymentLidiaGetCommissionRates(token, corporationId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-get-commission-rates`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: corporationId ? { corporationId } : {},
    });
  },

  PaymentLidiaSetCommissionRate(token, { corporationId, commissionRate, note = "" }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-set-commission-rate`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId, commissionRate, ...(note ? { note } : {}) },
    });
  },

  // --- Lidio ödeme (pazaryeri) ---
  // Kart bilgileri YALNIZ bu çağrıda taşınır; hiçbir yerde saklanmaz/loglanmaz.
  // Tutar ve komisyon SUNUCUDA borç satırlarından hesaplanır — FE tutar göndermez.
  PaymentLidiaInitPayment(token, payload) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-init-payment`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  // 3DS dönüşündeki query string BİLGİLENDİRMEDİR; nihai durum bu uçtan okunur.
  PaymentLidiaGetPaymentStatus(token, orderId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-get-payment-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { orderId },
    });
  },

  // Yalnız state="verification_required" olduğunda (banka CVV/OTP istediğinde) çağrılır.
  PaymentLidiaFinishPayment(token, orderId, { otp = "", cvv = "" } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-finish-payment`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { orderId, ...(otp ? { otp } : {}), ...(cvv ? { cvv } : {}) },
    });
  },

  // --- Lidio kayıtlı kartlar (token'lı) ---
  // Bu uçlar payment_instructions'ta provider='lidio' + token'lı kartları yönetir.
  // Ödemede instructionId ile bu kartlardan tahsilat yapılır (token SUNUCUDA çözülür).
  // Yanıt snake_case (instruction_id, card_last4...) gelir; FE camelCase'e MyPaymentsPage'de normalize eder.
  PaymentLidiaGetCards(token, customerId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-get-cards`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerId },
    });
  },

  // Kart ekler (tam PAN taşınır, YALNIZ bu istekte). Lidio token üretir; PAN saklanmaz.
  PaymentLidiaAddCard(token, { customerId, cardHolderName, cardNumber, cardMonth, cardYear, cardName = "" }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-add-card`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerId, cardHolderName, cardNumber, cardMonth, cardYear, ...(cardName ? { cardName } : {}) },
    });
  },

  PaymentLidiaSetDefaultCard(token, customerId, instructionId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-set-default-card`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerId, instructionId },
    });
  },

  PaymentLidiaDeleteCard(token, customerId, instructionId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/payment-lidia-delete-card`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { customerId, instructionId },
    });
  },

  GetPaymentCustomers(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-payment-customers`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {}
    });
  },

  // target: "partner" (Troy Depo -> firma) | "customer" (firma -> müşteri).
  // Verilmezse sunucu eski davranışa düşer (admin -> partner, merchant -> customer).
  UploadPaymentInvoice(token, debtID, file, target) {
    return axios({
      method: "post",
      url: `${API_URL}flow/upload-payment-invoice`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { debtID, file, ...(target ? { target } : {}) }
    });
  },
  // Yüklenmiş faturayı siler (yeniden yükleme için). Yetki: admin her ikisi, merchant customer.
  RemovePaymentInvoice(token, debtID, target) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-payment-invoice`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { debtID, target }
    });
  },

  // Kart ekle ("Kredi Kartlarım"). İlk kart daima varsayılan olur; sonrakiler için makeDefault.
  // autoChargeConsent: müşterinin "otomatik tahsilat" onayı — backend talimat kaydına yazar.
  CreatePaymentInstruction(token, card, makeDefault = false, autoChargeConsent = false) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-payment-instruction`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        cardHolder: card?.holder || "",
        cardLast4: card?.last4 || "",
        cardBrand: card?.brand || "",
        cardExpiry: card?.expiry || "",
        makeDefault: makeDefault ? 1 : 0,
        autoChargeConsent: autoChargeConsent ? 1 : 0,
      }
    });
  },

  // Varsayılan kart (otomatik ödemede kullanılacak kayıt) değiştirilir.
  SetDefaultPaymentInstruction(token, instructionID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-default-payment-instruction`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { instructionID }
    });
  },

  // instructionID verilmezse müşterinin TÜM kayıtlı kartları kaldırılır.
  RemovePaymentInstruction(token, instructionID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-payment-instruction`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: instructionID ? { instructionID } : {}
    });
  },
};

export default servisOdeme;
